import { css } from 'styled-system/css';
import { flex } from 'styled-system/patterns';

export const matchOutrightStyles = {
	teams: flex({
		_mars: {
			flex: '1',
			flexDirection: 'column',
			justifyContent: 'center',
			padding: '9px',
			gap: '9px',
			cursor: 'pointer',
		}
	}),
	team: flex({
		_mars: {
			alignItems: 'center',
			fontSize: '14px',
			wordBreak: 'break-word',
			justifyContent: 'space-between',
			lineHeight: '18px',
			gap: '6px',
			'& .odds-button': {
				flex: '1',
				marginBottom: '0',
				maxWidth: '240px',
				height: '30px',
			},
		}
	}),
	teamName: css({
		_mars: {
			flex: '2',
			alignItems: 'flex-start',
		}
	}),
}